export default "__VITE_ASSET__Cren6kr5__"